"use strict";

// IP_DEPOT_COMERCIAL_002
//
// Catalogo comercial obligatorio del frontend.
//
// ETAPA_COMERCIAL solo admite las seis etapas oficiales.
//
// GANADO:
// - No es una etapa oficial.
// - No se convierte automaticamente.
// - No se elimina de los datos historicos.
// - Debe marcarse para revision administrativa.
//
// Este modulo no modifica proyectos ni Google Sheets.

export const COMMERCIAL_STAGES = Object.freeze([
  Object.freeze({
    codigo: "OPORTUNIDAD",
    nombre: "Prospección",
    probabilidad: 10,
    orden: 1
  }),
  Object.freeze({
    codigo: "CALIFICACION",
    nombre: "Calificación",
    probabilidad: 25,
    orden: 2
  }),
  Object.freeze({
    codigo: "ANALISIS",
    nombre: "Análisis",
    probabilidad: 40,
    orden: 3
  }),
  Object.freeze({
    codigo: "PROPUESTA",
    nombre: "Propuesta / cotización",
    probabilidad: 60,
    orden: 4
  }),
  Object.freeze({
    codigo: "CONTRATACION",
    nombre: "Proceso de contratación",
    probabilidad: 80,
    orden: 5
  }),
  Object.freeze({
    codigo: "CIERRE_FIRMA",
    nombre: "Cierre y firma",
    probabilidad: 95,
    orden: 6
  })
]);

const BY_CODE = new Map(
  COMMERCIAL_STAGES.map(stage => [
    stage.codigo,
    stage
  ])
);

export function normalizeCommercialCode(value) {
  return String(value ?? "")
    .trim()
    .toUpperCase();
}

export function getCommercialStage(value) {
  return BY_CODE.get(
    normalizeCommercialCode(value)
  ) || null;
}

export function isOfficialCommercialStage(value) {
  return getCommercialStage(value) !== null;
}

export function validateCommercialStage(value) {
  const codigoOriginal = normalizeCommercialCode(value);
  const etapa = getCommercialStage(codigoOriginal);

  if (etapa) {
    return {
      valido: true,
      requiereRevision: false,
      codigoOriginal,
      etapa,
      probabilidad: etapa.probabilidad
    };
  }

  return {
    valido: false,
    requiereRevision: true,
    codigoOriginal,
    etapa: null,
    probabilidad: null,
    motivo:
      codigoOriginal === "GANADO"
        ? "GANADO_ES_RESULTADO_HISTORICO"
        : "ETAPA_COMERCIAL_NO_OFICIAL"
  };
}

export function getCommercialStageLabel(value) {
  const etapa = getCommercialStage(value);

  // Nunca inventar una etapa para un codigo invalido.
  return etapa
    ? etapa.nombre
    : "Etapa pendiente de homologación";
}

export function getCommercialStageProbability(value) {
  const etapa = getCommercialStage(value);

  // Nunca asignar 10%, 95% o 100% a GANADO.
  return etapa ? etapa.probabilidad : null;
}

// Conserva el objeto original.
// Solo agrega informacion derivada para su presentacion.
export function enrichCommercialProject(project) {
  if (!project || typeof project !== "object") {
    return project;
  }

  const raw =
    project.etapaComercial ??
    project.etapa_comercial ??
    project.ETAPA_COMERCIAL ??
    "";

  const commercial = validateCommercialStage(raw);

  return {
    ...project,
    commercialValidation: commercial
  };
}